/**
 * Maps `items` through `run` with at most `limit` runs in flight, resolving to the results in
 * the items' order. Fails fast: the first rejection rejects the whole call, but runs already in
 * flight are not cancelled. Rejects with a `RangeError` when `limit` is below 1 or NaN.
 */
export async function mapWithConcurrency<Item, Result>(
  items: readonly Item[],
  limit: number,
  run: (item: Item) => Promise<Result>,
): Promise<Result[]> {
  if (!(limit >= 1)) throw new RangeError("mapWithConcurrency limit must be at least 1");
  const results: Result[] = new Array(items.length);
  let next = 0;
  const worker = async () => {
    while (next < items.length) {
      const index = next;
      next += 1;
      results[index] = await run(items[index]);
    }
  };
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, worker));
  return results;
}
